import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { SolutionsSection } from './components/SolutionsSection';
import { StatsSection } from './components/StatsSection';
import { TeamSection } from './components/TeamSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-sans text-slate-300 selection:bg-brand-steel/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemsSection data-id="element-4" />
        <SolutionsSection data-id="element-5" />
        <StatsSection data-id="element-6" />
        <TeamSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ContactForm data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}